const e = {
  max: window.jQuery ? $.__("This value is above the maximum.") : "This value is above the maximum.",
  maxLength: window.jQuery ? $.__("Please shorten your response.") : "Please shorten your response.",
  min: window.jQuery ? $.__("This value is below the minimum.") : "This value is below the minimum.",
  minLength: window.jQuery ? $.__("We need a bit more detail here.") : "We need a bit more detail here.",
  pattern: window.jQuery ? $.__("Please enter a valid format.") : "Please enter a valid format.",
  required: window.jQuery ? $.__("Please fill in this field.") : "Please fill in this field.",
  requiredCheckbox: window.jQuery ? $.__("Please check this box to continue.") : "Please check this box to continue.",
  requiredCheckboxGroup: window.jQuery ? $.__("Please select at least one option.") : "Please select at least one option.",
  requiredRadioGroup: window.jQuery ? $.__("Please select an option.") : "Please select an option.",
  requiredSelection: window.jQuery ? $.__("Please make a selection.") : "Please make a selection.",
  requiredToggle: window.jQuery ? $.__("Please make a selection.") : "Please make a selection."
};
export {
  e as D
};
//# sourceMappingURL=default-error-messages.constants-BvAz67KV.mjs.map
